module.exports = __webpack_public_path__ + "static/media/poc_tree_recenter.05c4b24e.svg";